import React, { FC } from "react"
import { useToggle } from "../../../utils/Hooks"
import { ContentfulContentRenderer } from "../content-renderer"
import { IModal } from "contentful-types"
import { ContentfulContentProp } from "./shared-types"
import {
  Box,
  CloseIcon,
  Dialog,
  DialogContent,
  DialogContentText,
  IconButton,
  InternalIcon,
  Link,
  useMediaQuery,
  useTheme
} from "@carrotfertility/carotene-core"
import { useIntl } from "react-intl"

export const Modal: FC<ContentfulContentProp<IModal>> = ({ content }) => {
  const {
    fields: { linkText, content: internalContent, title }
  } = content
  const intl = useIntl()
  const [showModal, toggleShowModal] = useToggle(false)
  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"))

  return (
    <>
      <Link endIcon={<InternalIcon color="primary" fontSize="small" />} component="button" onClick={toggleShowModal}>
        {linkText}
      </Link>
      <Dialog aria-labelledby="modal-title" fullScreen={fullScreen} open={showModal} onClose={toggleShowModal}>
        <Box display="flex" justifyContent="flex-end">
          <IconButton aria-label={intl.formatMessage({ defaultMessage: "Close" })} onClick={toggleShowModal}>
            <CloseIcon />
          </IconButton>
        </Box>
        <DialogContent>
          {title ? (
            <DialogContentText
              id="modal-title"
              component="h2"
              variant="h2"
              paddingBottom={(theme) => theme.spacing(theme.tokens.spacing.xs)}
            >
              {title}
            </DialogContentText>
          ) : null}
          <ContentfulContentRenderer contents={internalContent} />
        </DialogContent>
      </Dialog>
    </>
  )
}
